import BigPandaLogo from '@src/icons/service-integrations/BigPanda.svg';
import DataDogLogo from '@src/icons/service-integrations/DataDog.svg';
import PagerDutyLogo from '@src/icons/service-integrations/PagerDuty.svg';
import {
  siBigpandaFeatureSelector,
  siDatadogFeatureSelector,
  siPagerDutyFeatureSelector,
  appSiPagerDutyFeatureSelector,
} from '@store/common/selectors';

const defaultPartners = {
  EI: {
    BigPanda: {
      logo: BigPandaLogo,
      featureFlag: siBigpandaFeatureSelector,
    },
    DataDog: {
      logo: DataDogLogo,
      featureFlag: siDatadogFeatureSelector,
    },
    PagerDuty: {
      logo: PagerDutyLogo,
      featureFlag: siPagerDutyFeatureSelector,
    },
  },
  APP: {
    PagerDuty: {
      logo: PagerDutyLogo,
      featureFlag: appSiPagerDutyFeatureSelector,
    },
  }
};

export function getIntegrationPartners(product) {
  const partnerList = Object.assign({}, defaultPartners[product]);

  return partnerList;
}
